module.exports = __webpack_public_path__ + "static/media/Appstore.a1e66258.png";